import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[appAutofocus]'
})
export class AutofocusDirective {
  @Input() appAutofocus;
  constructor(private el: ElementRef)
  {}

  ngOnInit()
  {
    if (this.appAutofocus || typeof this.appAutofocus === "undefined"){
      this.el.nativeElement.focus();
    }
  }

  @Input() set autofocus(condition: boolean)
  {
    this.appAutofocus = condition != false;
  }
}
